import React from 'react';
import { makeStyles, Container, Grid, Typography, } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import SearchIcon from '@material-ui/icons/Search';
import TimelineIcon from '@material-ui/icons/Timeline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Details from './component/Details';
import Edit from './component/Edit';
import LeaveRecordCollection from '../Function/LeaveRecordCollection';
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../API/customAxios";
import { FormattedMessage, useIntl } from 'react-intl';
import { tableStyle, getMuiTheme } from "../UIComponent/CommonStyle"
import { checkIsNewCompLeave } from '../Function/globalFunction';

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));

export default function MyLeave({ routing, routingId, source }) {
    const classes = useStyles();
    const intl = useIntl();
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [editId, setEditId] = React.useState();
    const [isNewCompLeave, setIsNewCompLeave] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const page = isNewCompLeave ? 'Comp Leave Reqs' : 'My Leave';

    React.useEffect(() => {
        if (routing !== '') {
            setEditId(routingId)
            setOpenEdit(routing);
        }
    }, [routing]);

    React.useEffect(() => {
        customAxios.get('/get_my_leaves')
            .then(res => {
                var getLeaveRecord = res.data;
                setData(LeaveRecordCollection(getLeaveRecord, 'MyLeave', intl));
                setShowCompetent(true);
            })
    }, []);

    const handleOpen = (id, isNewCompLeave) => {
        setShowId(id)
        setIsNewCompLeave(isNewCompLeave);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenEdit = (id, isNewCompLeave) => {
        setEditId(id)
        setIsNewCompLeave(isNewCompLeave);
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const options = {
        filterType: 'checkbox',
        elevation: 1,
        filter: true,
        download: false,
        print: false,
        search: false,
        selectableRows: 'none',
        textLabels: {
            body: {
                noMatch: intl.formatMessage({ id: 'table.no_match' }),
                toolTip: intl.formatMessage({ id: 'table.sort' }),
                columnHeaderTooltip: column => intl.formatMessage({ id: 'table.sort_for' }) + ` ${column.label}`
            },
            pagination: {
                next: intl.formatMessage({ id: 'table.next' }),
                previous: intl.formatMessage({ id: 'table.previous' }),
                rowsPerPage: intl.formatMessage({ id: 'table.rowsPerPage' }),
                displayRows: intl.formatMessage({ id: 'table.displayRows' }),
            },
            toolbar: {
                search: intl.formatMessage({ id: 'table.search' }),
                downloadCsv: intl.formatMessage({ id: 'table.downloadCsv' }),
                print: intl.formatMessage({ id: 'table.print' }),
                viewColumns: intl.formatMessage({ id: 'table.viewColumns' }),
                filterTable: intl.formatMessage({ id: 'table.filterTable' }),
            },
            filter: {
                all: intl.formatMessage({ id: 'table.all' }),
                title: intl.formatMessage({ id: 'table.filters' }),
                reset: intl.formatMessage({ id: 'table.reset' }),
            },
            viewColumns: {
                title: intl.formatMessage({ id: 'table.show_columns' }),
                titleAria: intl.formatMessage({ id: 'table.show_hide_table_columns' }),
            },
            selectedRows: {
                text: intl.formatMessage({ id: 'table.rows_selected' }),
                delete: "Delete",
                deleteAria: "Delete Selected Rows",
            },
        },
    };

    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "type",
            label: intl.formatMessage({ id: 'new_application.leave_type' }),
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "dateSubmitted",
            label: intl.formatMessage({ id: 'table.date_submitted' }),
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "startDate",
            label: intl.formatMessage({ id: 'common.from' }),
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "untilDate",
            label: intl.formatMessage({ id: 'common.to' }),
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "period",
            label: intl.formatMessage({ id: 'new_application.taken' }),
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "status",
            label: intl.formatMessage({ id: 'table.status' }),
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "details",
            label: intl.formatMessage({ id: 'myleave.progress' }),
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <TimelineIcon 
                            onClick={() => {
                                const isNewCompLeave = checkIsNewCompLeave(tableMeta.rowData[3]);
                                handleOpen(tableMeta.rowData[0], isNewCompLeave);
                            }} 
                            className={classes.muiDataTableIcon} 
                        />
                    );
                }
            }
        },
        {
            name: "edit",
            label: intl.formatMessage({ id: 'table.details' }),
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <SearchIcon 
                            onClick={() => {
                                const isNewCompLeave = checkIsNewCompLeave(tableMeta.rowData[3]);
                                handleOpenEdit(tableMeta.rowData[0], isNewCompLeave);
                            }} 
                            className={classes.muiDataTableIcon} 
                        />
                    );
                }
            }
        },
    ];

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
                {showCompetent ?
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography align="left" style={{ fontSize: '1.6em', fontWeight: 600 }}>
                                <>
                                    {intl.formatMessage({ id: 'navigation.my_requests' }) + ' - ' + intl.formatMessage({ id: 'navigation.leave' })}
                                </>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <MUIDataTable
                                    title={intl.formatMessage({ id: 'myleave.leave_record' })}
                                    data={data}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                }
            </Container>
            {open && <Details handleClose={handleClose} open={open} showId={showId} page={page} isNewCompLeave={isNewCompLeave}></Details>}
            {openEdit && <Edit handleClose={handleCloseEdit} open={openEdit} showId={editId} type={page} isNewCompLeave={isNewCompLeave} source={source}></Edit>}
        </main>
    );
}